// extracted by mini-css-extract-plugin
export default {"title":"styles_title__+KzJN","errorMessage":"styles_errorMessage__vK9-s"};